import React from 'react';

const Support = () => {
  return (
    <div className="min-h-screen bg-white dark:bg-gray-900">
      <div className="container max-w-4xl mx-auto px-4 py-8">
        {/* Header */}
        <h1 className="text-4xl font-bold mb-4 text-gray-900 dark:text-white">
          Assistance Remadia
        </h1>

        <p className="text-sm text-gray-500 dark:text-gray-400 mb-8">
          Dernière mise à jour : {new Date().toLocaleDateString('fr-FR')}
        </p>

        {/* Contact */}
        <section className="mb-8">
          <p className="mb-4 leading-relaxed text-gray-700 dark:text-gray-300">
            Pour toute question, assistance ou signalement concernant Remadia,
            contactez notre équipe.
          </p>
          <div className="space-y-2 text-gray-700 dark:text-gray-300">
            <p>
              <strong>Email :</strong>{' '}
              <a
                href="mailto:support@remadia.com"
                className="text-blue-600 dark:text-blue-400 underline"
              >
                support@remadia.com
              </a>
            </p>
          </div>
        </section>

        {/* Informations légales */}
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4 text-gray-800 dark:text-gray-200">
            Informations légales
          </h2>
          <ul className="list-disc list-inside space-y-2 ml-4 text-gray-700 dark:text-gray-300">
            <li>
              <a href="/legal/cgu" className="text-blue-600 dark:text-blue-400 underline">
                Conditions Générales d'Utilisation
              </a>
            </li>
            <li>
              <a href="/legal/privacy" className="text-blue-600 dark:text-blue-400 underline">
                Politique de confidentialité
              </a>
            </li>
            <li>
              <a href="/legal/mentions" className="text-blue-600 dark:text-blue-400 underline">
                Mentions légales
              </a>
            </li>
          </ul>
        </section>
      </div>
    </div>
  );
};

export default Support;
